import { useContext, useEffect, useState } from "react"
import Schudle from "./Schudle"
import Days from '../../data/days.json';
import Empty from "../empPage/empty";
import { useNavigate, useParams } from "react-router-dom";
import { action } from "../../context/action";
import { mainSearch, recodeNow, update } from "../indexDB/indexDBStora";
import { CheckUser } from "../../funcs/validateEmp";
import { useTransaction } from "../../funcs/hooks/usetransaction";
import { useTranslation } from "react-i18next";

export default function WorkForce ( props ) {
    const { t } = useTranslation();
    const {setErrorMessage} = useContext(action);
    const CODE = useParams().username || "";

    const intial = {
        holiday: [],
        shiftDates: {
            start: "",
            end: ""
        }
    }
    const [work, setWork] = useState(intial)
    const [holiday, setHoliDay] = useState(0)

    const navigate = useNavigate();

    const Reset = () => {
        navigate("/employees", {replace : true});
        setWork(intial);
        setHoliDay(0);
        return;
    }

    useEffect(() => {
        const Check = async () => {
            const getUser = await CheckUser(CODE);
            if(!getUser.status) {
                Reset();
                return;
            }
        }
        if(props.path === 'workTime') {
            Check();
        }
    
        }, [CODE, props.path])

    const record_transaction = useTransaction("record", "", true);

    const AddShift = async (e) => {
        e.preventDefault();

        // 🔴 Validation
        if (!work.shiftDates?.start || !work.shiftDates?.end) {
            setErrorMessage("ادخل بداية و نهاية وقت العمل");
            return;
        }

        if (!CODE) {
            setErrorMessage("ادخل كود الموظف");
            return;
        }

        if (new Date(work.shiftDates.end) <= new Date(work.shiftDates.start)) {
            setErrorMessage("وقت النهاية لازم يكون بعد البداية");
            return;
        }

        setErrorMessage("");

        try {
            // 🔵 get employee
            const getUser = await mainSearch("employees", CODE);

            if (!getUser) {
                setErrorMessage("الموظف غير موجود");
                return;
            }

            const updatedUser = {
                ...getUser,
                shift: { ...work }
            };

            const transactionData = {
                ...record_transaction.data,
                message: `تم تسجيل وقت العمل لموظف ${getUser.fullName}`
            };

            await update("employees", updatedUser);
            await recodeNow(transactionData, "transactions");

            Reset();

        } catch (err) {
            console.error(err);
            setErrorMessage("حصل خطأ أثناء تسجيل الشيفت");
        }
};

    return (
        props.path === "workTime" ?
        <div className="workforce">
            <form onSubmit={AddShift}>
                <div>
                    <div className="child">
                        <label>{t("auth:user")}</label>
                        <input disabled value={CODE} type="text" placeholder="USERNAME" />
                    </div>
                </div>
                <div className="flex">
                    <div className="child">
                        <label>{t("common:startIn")}</label>
                        <input type="time" 
                        value={work.shiftDates.start}
                        onChange={(e) => setWork((prev)=>({...prev, shiftDates: {
                            ...prev.shiftDates, start: e.target.value
                        }}))}/>
                    </div>
                    <div className="child">
                        <label>{t("common:endIn")}</label>
                        <input type="time"
                        value={work.shiftDates.end}
                        onChange={(e) => setWork((prev)=>({...prev, shiftDates: {
                            ...prev.shiftDates, end: e.target.value
                        }}))}
                        />
                    </div>
                </div>
                <div className="flex">
                    <div className="child">
                        <label>{t("label:shift.numberHoliday")}</label>
                        <input min={0}
                        max={6}
                        onChange={(e) => {
                            const value = e.target.value;
                            if(value < work.holiday.length) {
                                work.holiday.pop();
                            }
                            else {
                                setHoliDay(value)
                            }
                        }} 
                        value={holiday} type="number" placeholder="يوم الأجازة" />
                    </div>
                    <div className="child">
                        <label>{t("commn:holiday")}</label>
                        <select 
                        onChange={(e)=> setWork((prev) => ({...prev, holiday: [...prev.holiday, e.target.value]}))}
                        disabled={Number(holiday) === 0 || Number(holiday) <= work.holiday.length}>
                            <option selected disabled>{t("label:shift.holidays")}</option>
                            {Days.map((e, i) => 
                                <option disabled={work.holiday.includes(e.name)} key={i} value={e.name}>{t(`days:${e.title}`)}</option>
                            )}
                        </select>
                    </div>
                </div>
                <div className="right">
                    <button className="success-bg">{t("action:shift")}</button>
                    <button
                    type="button"
                    onClick={() => Reset()}
                    className="error">X</button>
                </div>
            </form>
            {work.holiday.length !== 0 && <Schudle work={work} />}
        </div>
        :
        <Empty mode="employee" />
    )
}